import React from 'react';
import { TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@mui/material/Autocomplete';

import { LISTBOX_PROPS, UnderTheField } from './autocompleteLook';

// Поле «Район» или «Населённый пункт» со списком подсказок. Можно выбрать подсказку, а можно
// вписать своё название. Значение передаётся и как value, и как
// inputValue: иначе поле само сбрасывает текст, не найдя его среди подсказок.
function PlaceField({ label, value, options, maxLength, helperText, onChange }) {
  return (
    <FormControl fullWidth>
      <Autocomplete
        freeSolo
        options={options}
        value={value || null}
        inputValue={value || ''}
        onInputChange={(event, text) => onChange(text)}
        PopperComponent={UnderTheField}
        ListboxProps={LISTBOX_PROPS}
        forcePopupIcon
        openText="Открыть список"
        closeText="Закрыть список"
        clearText="Очистить"
        noOptionsText="Нет подсказок"
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            helperText={helperText}
            inputProps={{ ...params.inputProps, maxLength }}
          />
        )}
      />
    </FormControl>
  );
}

export default PlaceField;
